import { Box, Divider, Skeleton, Stack } from '@mui/material';
import React, { Fragment } from 'react';

export const CustomerProfileShimmer: React.FC = () => {
  return (
    <Box>
      {/* Header Card */}
      <Box mb={2} p={2} borderRadius={3} bgcolor="#fff">
        <Stack direction="row" alignItems="center" spacing={2}>
          <Skeleton variant="circular" width={40} height={40} />

          <Box flex={1}>
            <Skeleton variant="text" width="60%" height={20} />
            <Skeleton variant="text" width="40%" height={18} />
          </Box>

          <Skeleton variant="circular" width={32} height={32} />
        </Stack>
        <Divider style={{ margin: '20px 0 15px' }} />
        <Skeleton variant="text" width="50%" />
      </Box>

      {/* Credit / Outstanding */}
      <Stack direction="row" spacing={2} mb={2}>
        {[1, 2].map((i) => (
          <Box key={i} flex={1} p={2} borderRadius={3} bgcolor="#fff">
            <Skeleton variant="text" width="60%" />
            <Skeleton
              variant="text"
              width="60%"
              height={40}
              style={{ marginTop: '10px' }}
            />
          </Box>
        ))}
      </Stack>

      {/* Collect Payment */}
      <Box mb={2} p={2} borderRadius={3} bgcolor="#fff">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Skeleton variant="text" width="40%" />
          <Skeleton variant="rounded" width={80} height={32} />
        </Stack>
      </Box>

      {/* List Items */}
      {[1, 2, 3].map((i) => (
        <Box key={i} mb={2} p={2} borderRadius={3} bgcolor="#fff">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Skeleton variant="rounded" width={40} height={40} />

            <Box flex={1}>
              <Skeleton variant="text" width="50%" />
              <Skeleton variant="text" width="30%" />
            </Box>

            <Skeleton variant="text" width="20%" height={40} />
          </Stack>
        </Box>
      ))}

      {/* Footer */}
      <Box mb={2} p={2} borderRadius={3} bgcolor="#fff">
        {[1, 2, 3, 4].map((i) => (
          <Fragment key={i}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Box flex={1}>
                <Skeleton key={i} variant="text" width="25%" height={30} />
              </Box>
              <Skeleton variant="text" width="5%" />
            </Stack>
            {i < 4 && <Divider style={{ margin: '10px 0' }} />}
          </Fragment>
        ))}
      </Box>
    </Box>
  );
};
